import { z } from 'zod';
import { aswapSchema } from './aswap.schema';
import { autocallConsolationSchema } from './autocall-consolation.schema';
import { autocallStandardSchema } from './autocall-standard.schema';
import { bondSchema } from './bond.schema';
import { digitalSchema } from './digital.schema';
import { diverOtcSchema } from './diver-otc.schema';
import { equityOtcSchema } from './equity-otc.schema';
import { equitySchema } from './equity.schema';
import { fundSchema } from './fund.schema';
import { fxfwdSchema } from './fxfwd.schema';
import { indexSchema } from './index.schema';
import { otherSchema } from './other.schema';
import { phoenixNonMemorySchema } from './phoenix-non-memory.schema';
import { rangeAccrualSchema } from './range-accrual.schema';
import { supertrackerSchema } from './supertracker.schema';
import { vanillaDigitalSchema } from './vanilla-digital.schema';
import { vanillaSpreadSchema } from './vanilla-spread.schema';
import { vanillaStructuredSchema } from './vanilla-structured.schema';
import { vanillaSchema } from './vanilla.schema';
export const allInstrumentsSchema = z.discriminatedUnion('instrument_type', [
    bondSchema,
    equitySchema,
    indexSchema,
    aswapSchema,
    fundSchema,
    fxfwdSchema,
    diverOtcSchema,
    equityOtcSchema,
    autocallStandardSchema,
    autocallConsolationSchema,
    phoenixNonMemorySchema,
    digitalSchema,
    vanillaSpreadSchema,
    vanillaStructuredSchema,
    rangeAccrualSchema,
    supertrackerSchema,
    vanillaSchema,
    vanillaDigitalSchema,
    otherSchema,
]);
